<template>
    <div class="content">
        <menus></menus>
        <div class="main">
            <!-- 内容 -->
            <!-- <div class="user">
                <span>{{ $t('welcome.welcome') }}</span><span>{{ phone }}</span><span
                    @click="signOut" style="color:#fff">{{ $t('welcome.signOut') }}</span>
            </div> -->
            <div>
                <div class="main_bottom meetingL_main">
                    <div class="meetingL" style=" text-align: center !important;font-size: .3rem;">
                        {{ $t('back.waiting') }}
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="back" @click="path('menu')" :style="{ 'font-size': $i18n.locale == 'jp' ? '.2rem' : '.28rem' }">
            <img width="100%" src="https://oss.eventnet.cn/H5/Nissan_meeting/2024/back.png" alt="">
        </div> -->
    </div>
</template>
<script>
import menus from "../components/menu.vue"
export default {
    components: {
        menus
    },
    name: "menuView",
    data () {
        return {
            phone: localStorage.getItem("nissan2023_meeting_mobile"),
            back: this.$route.query.name
        }
    },
    created () {
        //_hmt.push(['_trackPageview', '/waiting']);
        console.log(this.back);
    },
    mounted () {
        // this.alerts3("<p style='text-align:left;'>" + this.$t('tips.tips3') + "</p>");
    },
    methods: {
        alerts3 (content) {
            layer.open({
                title: [
                    this.$t('tips.tips1'),
                    'background-color: #c61533; color:#fff;'
                ],
                content: content,
                btn: this.$t('tips.tips2'),
                yes: function (index) {
                    layer.closeAll();
                }
            });
        },
        signOut () {
            localStorage.removeItem("nissan2023_meeting_uuid")
            this.$router.replace('/login');
        },
        path (path) {
            if (this.back == "" || this.back == null || this.back == undefined) {
                this.$router.replace('/' + path)
            } else {
                this.$router.replace('/' + this.back)
            }
        }
    }
}
</script>
<style scoped>
@import "../assets/css/index.css";
@import "../assets/css/common.css";
</style>


// WEBPACK FOOTER //
// src/views/waiting.vue